<template>
	<div>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Distribusi Serial</div>
		</div>
		<div v-if="loading">
			<!-- <loading-card></loading-card> -->
		</div>
		<div>
			<v-card class="mt-3 mb-3" outlined>
				<v-list color="deep-purple lighten-5" class="pa-3">
					<v-list-item dense class="px-1">
						<v-spacer></v-spacer>
						<v-btn text depressed class="primary mr-2" @click="exportData">
							<v-icon>mdi-export</v-icon>
							<div class="pl-2 text-capitalize">Export</div>
						</v-btn>
						<v-btn text depressed class="primary" @click="dropfilter = !dropfilter">
							<v-icon>mdi-filter</v-icon>
							<div class="pl-2 text-capitalize">Filter</div>
						</v-btn>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				<v-card outlined class="mb-3" v-if="dropfilter">
					<filterComponent @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
				</v-card>
			</v-slide-y-transition>
			<v-card outlined class="mt-3">
				<v-data-table loading :headers="headers" dense :items="salesSerialResults" hide-default-footer :options.sync="option" :server-items-length="salesSerialPagination.total_data" disable-pagination>
					<template v-slot:progress>
						<div>
						</div>
					</template>
					<template v-slot:loading>
						<div class="py-3" v-if="!salesSerialPagination">
							<loading-data></loading-data>
						</div>
						<div class="py-3" v-else>
							<not-found></not-found>
						</div>
					</template>
				</v-data-table>
			</v-card>
			<div class="pt-5">
				<v-row v-if="salesSerialPagination">
					<v-col cols="12" md="11" class="py-0 d-flex justify-end">
						<v-pagination @input="changePage" v-model="page" :length="salesSerialPagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus"></v-pagination>
					</v-col>
					<v-col cols="12" md="1" class="py-0 pl-0">
						<v-autocomplete :items="listLimit" @input="changeLimit" v-model="limit" hide-details class="mt-0" label="Item"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions,  mapState, mapMutations } from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			menu: false,
			loading: true,
			dropfilter: false,
			sortBy: '',
			sortDir: 'DESC',
			page: 1,
			limit: '100',
			listLimit: [ '50', '100', '200', '500' ],
			headers: [
			{ text: 'Kode Serial', value: 'sales_serial_value' },
			{ text: 'Kode SDO', value: 'sdo_code', sortable: true},
			{ text: 'Kode SO', value: 'so_code', sortable: true},
			{ text: 'Penjual Serial', value: 'warehouse_name', sortable: true},
			{ text: 'Pembeli Serial', value: 'customer_network_mid', sortable: true},
			],
			filterData: [{
				type: 'text',
				label: 'Kode Serial',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'sales_serial_value'
				}
			}, {
				type: 'text',
				label: 'Kode SDO',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'sdo_code'
				}
			}, {
				type: 'text',
				label: 'Kode SO',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'so_code'
				}
			}, {
				type: 'text',
				label: 'Warehouse',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'warehouse_name'
				}
			}, {
				type: 'text',
				label: 'Kode Pembeli (GS)',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'customer_network_mid'
				}
			}, 
			],
			params:[],
		}
	},
	computed: {
		...mapState('salesSerial', ['salesSerialResults', 'salesSerialPagination']),
		...mapState('auth', ['userData']),
	},
	methods: {
		...mapActions('salesSerial', ['getSalesSerial', 'exportSalesSerial']),
		...mapMutations('salesSerial', ['listSalesSerial']),
		...mapMutations(['setFilter']),

		async getData() {
			await this.getSalesSerial(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		async exportData() {
			let filter = await this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir})
			await this.exportSalesSerial(filter)
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		onResetFilter() {
			this.params = []
			this.getData()
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
	},
	created() {
		this.setFilter(this.filterData)
		this.$store.dispatch('setPageTitle', `Distribusi Serial`)
		this.getData()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getPO(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
			}
		}
	}
};
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
</style>